import * as cards from '@wix/auto_sdk_workflows_cards';
import * as phases from '@wix/auto_sdk_workflows_phases';
import * as workflows from '@wix/auto_sdk_workflows_workflows';

export { cards, phases, workflows };
